import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Grid,
  Typography,
  Button,
} from '@mui/material';
import FieldView from '../../../molecules/FieldView/FieldView';
import { getDateWithTimeZone } from '../../../../utils/formatter';
import { useNavigate } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { permissionsObj } from '../../../OnBoarding/Organization/RolesAndPermissions/constants/roles-permissions.constants';
import { useSelector } from 'react-redux';
import { EditOutlined } from '@mui/icons-material';

const SelfieFormView = (props) => {
  const { data, bgColor = '#f0f4f8', min, max } = props;
  const {
    pkId,
    fkUserId,
    locationLat,
    locationLong,
    geoLocation,
    attendanceDatetimeUtc,
    attendanceInputCode,
    attendanceInOutDirection,
    attendanceDatetimeTimezone,
    attendanceDatetimeTzOffset,
    createdUtc,
    userImageUrl,
    schedule,
    status,
  } = data || {};

  const { id, displayName, workSchedule } = fkUserId || {};
  const navigate = useNavigate();
  const timeZone = attendanceDatetimeTzOffset?.replace('UTC', '').trim();
  const { timeManagementPermission } = useSelector(
    (state) => state.modulePermissions
  );

  return (
    <Accordion sx={{ border: '1px solid #ccc', borderRadius: 2 }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          backgroundColor: bgColor,
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Box>
            <Typography variant="subtitle2">
              {attendanceInOutDirection === 'I' ? 'In' : 'Out' || 'New User'}:{' '}
              {attendanceDatetimeUtc
                ? getDateWithTimeZone(
                    attendanceDatetimeUtc,
                    'DD/MMM/YYYY hh:mm a',
                    timeZone
                  )
                : ''}
            </Typography>
          </Box>
          {attendanceInputCode === 'M' &&
            timeManagementPermission?.['attendance']?.[
              permissionsObj.allowEdit
            ] && (
              <Button
                variant="outlined"
                size="small"
                onClick={() =>
                  navigate(`/time-management/attendance/${pkId}`, {
                    state: {
                      minDate: min,
                      maxDate: max,
                    },
                  })
                }
                // color='secondary'
                sx={{
                  backgroundColor: 'rgba(255, 255, 255, 0.7)',
                  color: '#333',
                  borderColor: '#333',
                  fontWeight: 'bold',
                  boxShadow: 1,
                  backdropFilter: 'blur(2px)',
                  '&:hover': {
                    backgroundColor: '#f0f0f0',
                    borderColor: '#222',
                  },
                }}
                endIcon={<EditOutlined />}
              >
                Edit
              </Button>
            )}
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ paddingX: 3, paddingBottom: 3 }}>
        <Grid container rowSpacing={3} columnSpacing={8} pr={8}>
          <Grid item md={6} xs={12}>
            <FieldView labelText="Latitude" labelValue={locationLat} />
          </Grid>
          <Grid item md={6} xs={12}>
            <FieldView labelText="Longitude" labelValue={locationLong} />
          </Grid>
          <Grid item md={6} xs={12}>
            <FieldView
              labelText="User Captured Image"
              labelValue={
                <a
                  href={userImageUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{ pointerEvents: 'auto' }}
                >
                  {userImageUrl ? (
                    <img src={userImageUrl} height={40} alt="User" />
                  ) : (
                    ''
                  )}
                </a>
              }
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default SelfieFormView;
